import {
    AfterViewInit,
    Component,
    ComponentRef,
    Input,
    Type,
    ViewChild,
    ViewContainerRef,
    inject,
    output,
    ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'app-component-wrapper',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '<ng-container #container />'
})
export class TableComponentWrapperComponent implements AfterViewInit {
    @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() component: Type<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public readonly componentInit = output<any>();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    componentRef: ComponentRef<any>;

    ngAfterViewInit() {
        this.componentRef = this.container.createComponent(this.component);
        this.componentInit.emit(this.componentRef.instance);
    }
}
